import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import { getJobPostData } from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const JobApplication = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [jobposts, setJobPost] = useState([]);

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchJobPost = async () => {
      try {
        setLoading(true);
        const response = await getJobPostData();
        setJobPost(response.data || []);
      } catch (err) {
        console.error("Error fetching Job Post:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJobPost();
  }, []);

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Job Applications</h2>
          </div>

          {loading ? (
            <div className="text-center w-100 my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : jobposts.length === 0 ? (
            <div className="col-12">
              <div className="alert alert-info text-center">No jobs found.</div>
            </div>
          ) : (
            <table className="table mt-4 hj-table">
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Job Title</th>
                  <th>Posted On</th>
                  <th>Salary</th>
                  <th>Job Status</th>
                  <th>Total Applications</th>
                  <th>Pending Applications</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {jobposts.map((job, index) => (
                  <tr key={job._id || index}>
                    <td>{index + 1}</td>
                    <td>{job.jobTitle}</td>
                    <td>{job.jobPosted}</td>
                    <td>
                      ₹{job.minSalary || ""} - {job.maxSalary || ""} <br></br>(
                      {job.salaryType || ""})
                    </td>
                    <td>
                      <span
                        style={{
                          backgroundColor:
                            job.status === "active"
                              ? "#00e721"
                              : job.status === "inactive"
                              ? "#e71b00"
                              : "#e7b100",
                          padding: "2px 12px",
                          borderRadius: "15px",
                          color: "#fff",
                        }}
                      >
                        {job.status || "Expired"}
                      </span>
                    </td>
                    <td>{job.appliedCandidates}</td>
                    <td>{job.applicationsPending}</td>
                    <td>
                      <div className="d-flex">
                        <a
                          href={`/job-details/${job._id}`}
                          className="mainbtn"
                          target="_blank"
                          style={{
                            backgroundColor: "#270b79",
                            border: "1px solid #270b79",
                          }}
                        >
                          View Job
                        </a>
                        &nbsp;
                        <a
                          href={`/employer/application-list/${job._id}`}
                          className="mainbtn"
                        >
                          Applications
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default JobApplication;
